import { t } from 'i18next';

export interface PermissionGroup {
  name: string;
  label: string;
  permissions: string[];
  checkboxValue: string;
}

export const PPMpermissionGroups = () => [
  {
    name: 'PPMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: [
      'PPMProjectCreate',
      'WorkPackageCreate',
      'TaskCreate',
      'ProjectInputCreate',
      'KanbanCreate',
      'DeliverableCreate',
      'TestCreate',
      'PPMStateCreate',
      'PPMTransactionCreate',
    ],
    checkboxValue: '11', // value for the PpmCreate permission
  },
  {
    name: 'PPMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: [
      'PPMProjectRead',
      'WorkPackageRead',
      'TaskRead',
      'ProjectInputRead',
      'KanbanRead',
      'DeliverableRead',
      'TestRead',
      'PPMStateRead',
      'PPMTransactionRead',
    ],
    checkboxValue: '12', // value for the PpmRead permission
  },

  {
    name: 'PPMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: [
      'PPMProjectUpdate',
      'WorkPackageUpdate',
      'TaskUpdate',
      'ProjectInputUpdate',
      'KanbanUpdate',
      'DeliverableUpdate',
      'TestUpdate',
      'PPMStateUpdate',
      'PPMTransactionUpdate',
    ],

    checkboxValue: '13', // value for the PpmUpdate permission
  },
  {
    name: 'PPMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: [
      'PPMProjectDelete',
      'WorkPackageDelete',
      'TaskDelete',
      'ProjectInputDelete',
      'KanbanDelete',
      'DeliverableDelete',
      'TestDelete',
      'PPMStateDelete',
      'PPMTransactionDelete',
    ],

    checkboxValue: '14', // value for the PpmDelete permission
  },
];

export const OMMpermissionGroups = () => [
  {
    name: 'OMMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: ['ObjectiveCreate', 'TOReportCreate', 'OMMStateCreate', 'OMMTransactionCreate'],
    checkboxValue: '21', // value for the OmmCreate permission
  },
  {
    name: 'OMMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: ['ObjectiveRead', 'TOReportRead', 'OMMStateRead', 'OMMTransactionRead'],
    checkboxValue: '22', // value for the OmmRead permission
  },

  {
    name: 'OMMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: ['ObjectiveUpdate', 'TOReportUpdate', 'OMMStateUpdate', 'OMMTransactionUpdate'],
    checkboxValue: '23', // value for the OmmUpdate permission
  },
  {
    name: 'OMMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: ['ObjectiveDelete', 'TOReportDelete', 'OMMStateDelete', 'OMMTransactionDelete'],
    checkboxValue: '24', // value for the OmmDelete permission
  },
];

export const FMMpermissionGroups = () => [
  {
    name: 'FMMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: [
      'IncidentFolderCreate',
      'IncidentCreate',
      'InjectionCreate',
      'ActionCreate',
      'OutcomeCreate',
      'ObservationTaskCreate',
      'FMMStateCreate',
      'FMMTransactionCreate',
    ],
    checkboxValue: '31', // value for the FmmCreate permission
  },
  {
    name: 'FMMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: [
      'IncidentFolderRead',
      'IncidentRead',
      'InjectionRead',
      'ActionRead',
      'OutcomeRead',
      'ObservationTaskRead',
      'FMMStateRead',
      'FMMTransactionRead',
      'TOAndIncidentChartRead',
      'MainIncidentListRead',
    ],
    checkboxValue: '32', // value for the FmmRead permission
  },

  {
    name: 'FMMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: [
      'IncidentFolderUpdate',
      'IncidentUpdate',
      'InjectionUpdate',
      'ActionUpdate',
      'OutcomeUpdate',
      'ObservationTaskUpdate',
      'FMMStateUpdate',
      'FMMTransactionUpdate',
    ],

    checkboxValue: '33', // value for the FmmUpdate permission
  },
  {
    name: 'FMMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: [
      'IncidentFolderDelete',
      'IncidentDelete',
      'InjectionDelete',
      'ActionDelete',
      'OutcomeDelete',
      'ObservationTaskDelete',
      'FMMStateDelete',
      'FMMTransactionDelete',
    ],

    checkboxValue: '34', // value for the FmmDelete permission
  },
];

export const RLSMpermissionGroups = () => [
  {
    name: 'RLSMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: [
      'ConfigurationChangeRequestCreate',
      'TroubleTicketCreate',
      'TechnicalSupportRequestCreate',
      'RLSMStateCreate',
      'RLSMTransactionCreate',
    ],
    checkboxValue: '41', // value for the RlsmCreate permission
  },
  {
    name: 'RLSMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: [
      'ConfigurationChangeRequestRead',
      'TroubleTicketRead',
      'TechnicalSupportRequestRead',
      'RLSMStateRead',
      'RLSMTransactionRead',
      'RegistryRead',
    ],
    checkboxValue: '42', // value for the RlsmRead permission
  },

  {
    name: 'RLSMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: [
      'ConfigurationChangeRequestUpdate',
      'TroubleTicketUpdate',
      'TechnicalSupportRequestUpdate',
      'RLSMStateUpdate',
      'RLSMTransactionUpdate',
      'RegistryUpdate',
    ],

    checkboxValue: '43', // value for the RlsmUpdate permission
  },
  {
    name: 'RLSMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: [
      'ConfigurationChangeRequestDelete',
      'TroubleTicketDelete',
      'TechnicalSupportRequestDelete',
      'RLSMStateDelete',
      'RLSMTransactionDelete',
      'RegistryDelete',
    ],

    checkboxValue: '44', // value for the RlsmDelete permission
  },
];

export const EMMpermissionGroups = () => [
  {
    name: 'EMMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: ['ExperimentationCreate', 'HymotseCreate'],
    checkboxValue: '51', // value for the EmmCreate permission
  },
  {
    name: 'EMMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: ['ExperimentationRead', 'HymotseRead'],
    checkboxValue: '52', // value for the EmmRead permission
  },

  {
    name: 'EMMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: ['ExperimentationUpdate', 'HymotseUpdate'],
    checkboxValue: '53', // value for the EmmUpdate permission
  },
  {
    name: 'EMMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: ['ExperimentationDelete', 'HymotseDelete'],
    checkboxValue: '54', // value for the EmmDelete permission
  },
];

export const LILLpermissionGroups = () => [
  {
    name: 'LILLCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: ['LillCreate', 'LILLStateCreate', 'LILLTransactionCreate'],
    checkboxValue: '61', // value for the LillCreate permission
  },
  {
    name: 'LILLRead',
    label: t('administration.userRights.permissions.read'),
    permissions: ['LillRead', 'LILLStateRead', 'LILLTransactionRead'],
    checkboxValue: '62', // value for the LillRead permission
  },

  {
    name: 'LILLUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: [
      'LillUpdate',
      'LillObserverUpdate',
      'LillProprietorUpdate',
      'LillAnalystUpdate',
      'LillTaskingAuthorityUpdate',
      'LillActionBodyUpdate',
      'LILLStateUpdate',
      'LILLTransactionUpdate',
    ],
    checkboxValue: '63', // value for the LillUpdate permission
  },
  {
    name: 'LILLDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: ['LillDelete', 'LILLStateDelete', 'LILLTransactionDelete'],
    checkboxValue: '64', // value for the LillDelete permission
  },
];

export const SSMpermissionGroups = () => [
  {
    name: 'SSMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: ['GeostrategicSituationCreate', 'RoadToCurrentSettingCreate', 'ActorBooksCreate'],
    checkboxValue: '71', // value for the SsmCreate permission
  },
  {
    name: 'SSMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: ['GeostrategicSituationRead', 'RoadToCurrentSettingRead', 'ActorBooksRead'],
    checkboxValue: '72', // value for the SsmRead permission
  },

  {
    name: 'SSMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: ['GeostrategicSituationUpdate', 'RoadToCurrentSettingUpdate', 'ActorBooksUpdate'],
    checkboxValue: '73', // value for the SsmUpdate permission
  },
  {
    name: 'SSMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: ['GeostrategicSituationDelete', 'RoadToCurrentSettingDelete', 'ActorBooksDelete'],
    checkboxValue: '74', // value for the SsmDelete permission
  },
];

export const ADMINISTRATIONpermissionGroups = () => [
  {
    name: 'ADMINISTRATIONCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: ['OntologiesCreate', 'EventCreate', 'UserRightsCreate', 'UserCreate', 'SettingCreate'],
    checkboxValue: '81', // value for the AdministrationCreate permission
  },
  {
    name: 'ADMINISTRATIONRead',
    label: t('administration.userRights.permissions.read'),
    permissions: ['OntologiesRead', 'EventRead', 'UserRightsRead', 'UserRead', 'SettingRead'],
    checkboxValue: '82', // value for the AdministrationRead permission
  },

  {
    name: 'ADMINISTRATIONUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: ['OntologiesUpdate', 'EventUpdate', 'UserRightsUpdate', 'UserUpdate', 'SettingUpdate'],
    checkboxValue: '83', // value for the AdministrationUpdate permission
  },
  {
    name: 'ADMINISTRATIONDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: ['OntologiesDelete', 'EventDelete', 'UserRightsDelete', 'UserDelete', 'SettingDelete'],
    checkboxValue: '84', // value for the AdministrationDelete permission
  },
];

export const ODC2MpermissionGroups = () => [
  {
    name: 'ODC2MCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: [
      'PhaseCreate',
      'LOECreate',
      'PlanOrderReportProcessCreate',
      'DecisiveConditionsCreate',
      'ODTaskCreate',
      'EffectCreate',
      'WargamingTurnChartCreate',
      'TasksEffectDCReportCreate',
      'OperationalDesignReportCreate',
      'ODC2MStateCreate',
      'ODC2MTransactionCreate',
      'ODC2MRiskCreate',
    ],
    checkboxValue: '91', // value for the ODC2M permission
  },
  {
    name: 'ODC2MRead',
    label: t('administration.userRights.permissions.read'),
    permissions: [
      'PhaseRead',
      'LOERead',
      'PlanOrderReportProcessRead',
      'DecisiveConditionsRead',
      'ODTaskRead',
      'EffectRead',
      'WargamingTurnChartRead',
      'TasksEffectDCReportRead',
      'OperationalDesignReportRead',
      'ODC2MStateRead',
      'ODC2MTransactionRead',
      'ODC2MRiskRead',
    ],
    checkboxValue: '92', // value for the ODC2M permission
  },

  {
    name: 'ODC2MUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: [
      'PhaseUpdate',
      'LOEUpdate',
      'PlanOrderReportProcessUpdate',
      'DecisiveConditionsUpdate',
      'ODTaskUpdate',
      'EffectUpdate',
      'WargamingTurnChartUpdate',
      'TasksEffectDCReportUpdate',
      'OperationalDesignReportUpdate',
      'ODC2MStateUpdate',
      'ODC2MTransactionUpdate',
      'ODC2MRiskUpdate',
    ],
    checkboxValue: '93', // value for the ODC2M permission
  },
  {
    name: 'ODC2MDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: [
      'PhaseDelete',
      'LOEDelete',
      'PlanOrderReportProcessDelete',
      'DecisiveConditionsDelete',
      'ODTaskDelete',
      'EffectDelete',
      'WargamingTurnChartDelete',
      'TasksEffectDCReportDelete',
      'OperationalDesignReportDelete',
      'ODC2MStateDelete',
      'ODC2MTransactionDelete',
      'ODC2MRiskDelete',
    ],
    checkboxValue: '94', // value for the ODC2M permission
  },
];

export const COAMpermissionGroups = () => [
  {
    name: 'COAMCreate',
    label: t('administration.userRights.permissions.add'),
    permissions: ['COAMCoaDevelopmentCreate', 'COAMRiskCreate', 'COAMCoaAnalysisCreate'],
    checkboxValue: '101', // value for the COAM permission
  },
  {
    name: 'COAMRead',
    label: t('administration.userRights.permissions.read'),
    permissions: ['COAMCoaDevelopmentRead', 'COAMSyncMatrixRead', 'COAMRiskRead', 'COAMCoaAnalysisRead'],
    checkboxValue: '102', // value for the COAM permission
  },

  {
    name: 'COAMUpdate',
    label: t('administration.userRights.permissions.modify'),
    permissions: ['COAMCoaDevelopmentUpdate', 'COAMSyncMatrixUpdate', 'COAMRiskUpdate', 'COAMCoaAnalysisUpdate'],

    checkboxValue: '103', // value for the COAM permission
  },
  {
    name: 'COAMDelete',
    label: t('administration.userRights.permissions.delete'),
    permissions: ['COAMCoaDevelopmentDelete', 'COAMRiskDelete', 'COAMCoaAnalysisDelete'],
    checkboxValue: '104', // value for the COAM permission
  },
];
